(() => {
  const config = document.getElementById('sm-product-view-config');
  if (!config || config.dataset.productViewsReady) return;
  config.dataset.productViewsReady = 'true';
  const api = config.dataset.api;
  const containers = new Map();
  const counts = new Map();
  const pageId = crypto.randomUUID().replaceAll('-', '');
  let visitorId;
  let activeAt = Date.now();
  let history = {};
  const historyReady = fetch(config.dataset.history,{cache:'force-cache'})
    .then(response => response.ok ? response.json() : null)
    .then(data => { history = {handles:data?.handles || {}}; })
    .catch(() => {});
  function trackingAllowed() {
    return config.dataset.track === 'true' && !document.hidden && Date.now()-activeAt < 300000 && (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed || window.Shopify.customerPrivacy.analyticsProcessingAllowed());
  }
  function visitor() {
    if (!visitorId) {
      try {
        const saved=JSON.parse(localStorage.getItem('sm_activity_browser_v1') || 'null');
        if (/^[a-zA-Z0-9_-]{20,80}$/.test(saved?.id) && Date.now()-saved.at<1800000) visitorId=saved.id;
      } catch {}
      visitorId ||= crypto.randomUUID().replaceAll('-','');
    }
    try { localStorage.setItem('sm_activity_browser_v1',JSON.stringify({id:visitorId,at:Date.now()})); } catch {}
    return visitorId;
  }
  function badge(parent, id, target) {
    if (!parent || !id || parent.querySelector('.sm-view-stats')) return;
    const element = document.createElement('span');
    element.className = 'sm-view-stats';
    element.hidden = true;
    element.dataset.smViewsFor = id;
    if (target) target.after(element); else parent.append(element);
  }
  function scan() {
    document.querySelectorAll('a[href*="/products/"]').forEach(link => {
      try {
        const url = new URL(link.href,location.href);
        const match = url.pathname.match(/\/products\/([^/]+)/);
        const id = match && url.origin === location.origin ? history.handles?.[decodeURIComponent(match[1])] : null;
        const card = id && link.closest('article,.product-thumb,.sm-product-upsell__card,.smg5-card,.smbb-slide');
        if (card && !card.dataset.smViewProduct) card.dataset.smViewProduct = id;
      } catch {}
    });
    document.querySelectorAll('[data-sm-view-product]').forEach(parent => badge(parent,parent.dataset.smViewProduct,parent.querySelector('.smcs-price,.sm-recent-price,.smcs-hero-price,.product-thumb-caption-price,.product-item-caption-price,.sm-product-upsell__body h3,.smbb-meta strong,.smbb-slide-meta strong,.smv25__price,.smg5-card-meta strong,.smg5-piece-price,.sma2-info p')));
    if (config.dataset.product) document.querySelectorAll('.product-item-caption-price').forEach(price => badge(price.parentElement,config.dataset.product,price));
    containers.clear();
    document.querySelectorAll('[data-sm-views-for]').forEach(element => {
      const id = element.dataset.smViewsFor;
      if (!containers.has(id)) containers.set(id,[]);
      containers.get(id).push(element);
    });
  }
  function eyeIcon() {
    const eye = document.createElementNS('http://www.w3.org/2000/svg','svg');
    for (const [name,value] of Object.entries({viewBox:'0 0 24 24',width:'16',height:'16',fill:'none',stroke:'currentColor','stroke-width':'1.7','aria-hidden':'true',focusable:'false'})) eye.setAttribute(name,value);
    const outline = document.createElementNS(eye.namespaceURI,'path');
    outline.setAttribute('d','M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z');
    const pupil = document.createElementNS(eye.namespaceURI,'circle');
    pupil.setAttribute('cx','12'); pupil.setAttribute('cy','12'); pupil.setAttribute('r','3');
    eye.append(outline,pupil);
    return eye;
  }
  function positive(value) {
    return Number.isSafeInteger(value) && value>0;
  }
  function paint() {
    for (const [id,elements] of containers) {
      const entry=counts.get(id);
      const fresh=entry && Date.now()-entry.at<30000;
      const values=fresh ? entry.value : {};
      for (const element of elements) {
        element.replaceChildren();
        element.hidden=true;
        for (const [key,label,detail] of [
          ['viewing_now','viewingLabel','viewingDetail'],
          ['active_carts',values.active_carts===1?'cartOneLabel':'cartLabel','cartDetail']
        ]) {
          if (!positive(values[key])) continue;
          const part=document.createElement('span');
          part.className='sm-activity-count';
          part.append(eyeIcon(),document.createTextNode(config.dataset[label].replace('__COUNT__',new Intl.NumberFormat().format(values[key]))));
          part.title=config.dataset[detail];
          element.append(part);
          element.hidden=false;
        }
        element.removeAttribute('title');
        element.setAttribute('data-sm-activity-ready','true');
        element.setAttribute('aria-label',element.textContent);
      }
    }
  }
  async function cartSnapshot() {
    try {
      const response=await fetch((config.dataset.root || '/')+'cart.js',{cache:'no-store',signal:AbortSignal.timeout(5000)});
      if (!response.ok) return null;
      const cart=await response.json();
      if (!Array.isArray(cart.items) || cart.items.length>100) return null;
      const items=cart.items.filter(item => item.quantity>0).map(item => ({product_id:String(item.product_id),handle:item.handle || item.url?.match(/\/products\/([^/?]+)/)?.[1]}));
      if (items.some(item => !/^[1-9][0-9]{9,19}$/.test(item.product_id) || !/^[a-z0-9][a-z0-9-]{0,199}$/.test(item.handle || ''))) return null;
      return [...new Map(items.map(item => [item.product_id,item])).values()];
    } catch { return null; }
  }
  let running=false;
  let pending=false;
  let reporting=false;
  function leave() {
    if (!visitorId || !reporting) return;
    reporting=false;
    fetch(api,{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify({visitor_id:visitorId,page_id:pageId,view:null,cart:null}),keepalive:true}).catch(() => {});
  }
  async function refresh() {
    if (running) { pending=true; return; }
    if (document.hidden) return;
    running=true;
    try {
      await historyReady;
      scan();
      paint();
      if (trackingAllowed()) {
        const cart=await cartSnapshot();
        if (!trackingAllowed()) return;
        const view=config.dataset.product ? {product_id:config.dataset.product,handle:config.dataset.handle} : null;
        try {
          reporting=true;
          const response=await fetch(api,{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify({visitor_id:visitor(),page_id:pageId,view,cart}),signal:AbortSignal.timeout(8000)});
          if (!response.ok) throw new Error('Activity unavailable');
        } catch {}
        if (!trackingAllowed()) leave();
      } else leave();
      const ids=[...containers.keys()].filter(id => /^[1-9][0-9]{9,19}$/.test(id));
      for (let offset=0;offset<ids.length;offset+=100) {
        const batch=ids.slice(offset,offset+100);
        try {
          const response=await fetch(api+'?ids='+batch.join(','),{credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(8000)});
          if (!response.ok) throw new Error('Activity unavailable');
          const data=await response.json();
          if (data.version!==1 || !data.products) throw new Error('Invalid activity');
          batch.forEach(id => counts.set(id,{at:Date.now(),value:data.products[id] || {}}));
        } catch { batch.forEach(id => counts.delete(id)); }
        paint();
      }
    } finally {
      running=false;
      if (pending) { pending=false; refresh(); }
    }
  }
  let timer;
  const observer=new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType===1 && (node.matches('[data-sm-view-product],a[href*="/products/"]') || node.querySelector('[data-sm-view-product],a[href*="/products/"]'))))) {
      clearTimeout(timer); timer=setTimeout(refresh,150);
    }
  });
  observer.observe(document.body,{childList:true,subtree:true});
  for (const name of ['pointerdown','keydown','scroll','touchstart']) document.addEventListener(name,() => { activeAt=Date.now(); },{passive:true});
  for (const name of ['cart:updated','cart:change','cart:refresh','product:added']) document.addEventListener(name,refresh);
  document.addEventListener('submit',event => {
    if (event.target.matches('form[action*="/cart"]')) setTimeout(refresh,1200);
  });
  document.addEventListener('visibilitychange',() => {
    if (document.hidden) { leave(); counts.clear(); paint(); }
    else { activeAt=Date.now(); refresh(); }
  });
  document.addEventListener('visitorConsentCollected',refresh);
  window.addEventListener('pagehide',leave);
  window.addEventListener('pageshow',() => { activeAt=Date.now(); refresh(); });
  refresh();
  setInterval(refresh,20000);
  setInterval(paint,5000);
})();
